import { Charts } from './Charts';
import FinancingChartsDataProvider from './contexts/FinancingChartsDataContext';

const FinancingWrapper = () => {
    return (
        <FinancingChartsDataProvider>
            <Charts />
        </FinancingChartsDataProvider>
    );
};

export default FinancingWrapper;
